export class ParamStore {
  private store = new Map<string, Record<string, unknown>>();

  set(targetBlock: string, params: Record<string, unknown>): void {
    this.store.set(targetBlock, { ...this.store.get(targetBlock), ...params });
  }

  get(targetBlock: string): Record<string, unknown> | undefined {
    return this.store.get(targetBlock);
  }

  clear(targetBlock: string): void {
    this.store.delete(targetBlock);
  }

  has(targetBlock: string): boolean {
    return this.store.has(targetBlock);
  }

  dispose(): void {
    this.store.clear();
  }
}
